import { CommonModule } from '@angular/common';
import { Component, Inject, NgModule, OnInit, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-information-panel',
  templateUrl: './information-panel.component.html',
  styleUrls: ['./information-panel.component.scss']
})
export class InformationPanelComponent implements OnInit {

  constructor(@Optional() public dialogRef: MatDialogRef<InformationPanelComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    console.log(this.data);
  }

}
@NgModule({
  declarations: [
    InformationPanelComponent
  ],
  entryComponents: [
    InformationPanelComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
  ]
})
export class InformationPanelModule { }
